import { isEmpty, isNil, isString, isUndefined } from "lodash-es";
import { ensure, ensureArray, TType } from "types/service";

import { IURLSearchParams, urlSearchParamsConfig, urlSortConfigType } from "@/core/url";
import { codelistType, ICodelist } from "@/data/codelists";
import { IJobApplicationFilterValues } from "@/data/job-applications/types";
import { IWithRoutePropsProps } from "@/infrastructure/Route";

export interface IApplicationURLFilter {
  query?: string;
  contactPersonProfileIds?: Array<number>;
  showClosed?: boolean;
  status?: Array<ICodelist>;
  candidateIds?: Array<number>;
}

const configApplicationsURLFilterType: TType<IApplicationURLFilter> = {
  query: v => (v ? v : undefined),
  contactPersonProfileIds: v => (!isEmpty(v) ? v : undefined),
  showClosed: v => (v ? v : undefined),
  status: v => (isEmpty(v) ? undefined : ensureArray(codelistType)(v)),
  candidateIds: v => (!isEmpty(v) ? v : undefined),
};

export const applicationsURLFilterType = ensure(configApplicationsURLFilterType);

export interface IFiltersConfig {
  filters: IJobApplicationFilterValues;
}

export const configFiltersConfig: TType<IFiltersConfig> = {
  filters: v => v || {},
};

export const filtersConfigType = ensure(configFiltersConfig);

export interface IJobApplicationListSearchParams extends IURLSearchParams {
  filtersConfig: IApplicationURLFilter;
}

export const configJobApplicationListSearchParams: TType<IJobApplicationListSearchParams> = {
  ...urlSearchParamsConfig,
  sortConfig: v =>
    isNil(v)
      ? [
          {
            sortBy: "createdDate",
            order: "DESC",
          },
        ]
      : ensureArray(urlSortConfigType)(v),
  filtersConfig: v =>
    isEmpty(v) && isUndefined(v)
      ? {
          status: [{ code: "DRAFT" }, { code: "SUBMITTED" }, { code: "PRESENTED_TO_CLIENT" }, { code: "INTERVIEW" }],
        }
      : applicationsURLFilterType(v),
};

export const jobApplicationListSearchParamsType = ensure(configJobApplicationListSearchParams);

export interface IApplicationsRouteParams {
  applicationId: number;
}

export interface IApplicationsRouteProps extends IWithRoutePropsProps<IApplicationsRouteParams> {}

export const configApplicationsPatchParamsType: TType<IApplicationsRouteParams> = {
  applicationId: v => (isString(v) ? parseInt(v, 10) : NaN),
};

export const applicationsPatchParamsType = ensure(configApplicationsPatchParamsType);
